import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router';
import { selectedDateWithoutTime } from '@store/global/selectors';
import { selectValidParams, selectDateRange, selectGridData } from '@pages/reporting-pages/redated-orders/store/selectors';
import { RedatedParams } from '@api/order-reporting/types/RedatedParams';
import { setSearchParameters, setDateRange } from '@pages/reporting-pages/redated-orders/store/slice';
import { DateRange } from '@project-types/DateRange';
import { useResetRedatedOrdersMutation } from '@api/order-reporting/api';
import { AppPage } from 'components/app-page/AppPage';
import ParamsToolbar from '@pages/reporting-pages/redated-orders/params-toolbar/ParamsToolbar';
import Grid from '@pages/reporting-pages/redated-orders/grid/Grid';
import { headersObject } from '@pages/reporting-pages/redated-orders/headersObject';



const RedatedOrders = () => {

	const validParams = useSelector(selectValidParams);
	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const dateRange = useSelector(selectDateRange);
	const gridData = useSelector(selectGridData);

	const [ search, setSearch ] = useSearchParams();
	const dispatch = useDispatch();
	const updateSearchParameters = (parameters: RedatedParams) => dispatch(setSearchParameters(parameters));
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));

	const [ resetRedatedOrders ] = useResetRedatedOrdersMutation();


	useEffect(() => {
		if (!dateRange) {
			updateDateRange({ from: dateWithoutTime, to: dateWithoutTime });
		}
	}, []);

	
	useEffect(() => {
		if (validParams) {
			setSearch({ ...validParams }, { replace: true });
		}
	}, [ validParams ]);

	
	useEffect(() => {
		if (search) {
			let paramDateFrom = search.get('dateFrom');
			let paramDateTo = search.get('dateTo');
			let paramDc = search.get('dc');
			let paramfilterDate = search.get('filterDate');

			if (!paramDateFrom || !paramDateTo) return;

			let newSearchParams: RedatedParams = {
				dateFrom: paramDateFrom,
				dateTo: paramDateTo,
				...(paramDc && { dc: paramDc }),
				...(paramfilterDate && { filterDate: paramfilterDate }),
			}
			updateSearchParameters(newSearchParams);
		}
	}, [ search ]);


	const resetAllApi = useCallback(() => {
		resetRedatedOrders();
	},[]);


	return (
		<AppPage
			className='reporting-page redated-orders'
			pageLabel='Report - Předatumované objednávky'
			resetPageApi={resetAllApi}
			csvData={{
				headers: headersObject,
				data: gridData,
				filename: 'reporting-predatumovane-objednavky',
			}}
		>
			<ParamsToolbar />
			<Grid />
		</AppPage>
	)
};

export default RedatedOrders;